import { Template } from 'components/base/Template/Template';

export const NotFoundPage = () => {
  return <Template>NotFound 404</Template>;
};
